var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShowProfileIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_42308_1517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.33368 18.1815C3.83583 18.3337 4.51407 18.3337 5.66699 18.3337H14.3337C15.4866 18.3337 16.1648 18.3337 16.667 18.1815M3.33368 18.1815C3.22601 18.1489 3.12644 18.1093 3.03202 18.0612C2.56161 17.8215 2.17916 17.439 1.93948 16.9686C1.66699 16.4339 1.66699 15.7338 1.66699 14.3337V5.66699C1.66699 4.26686 1.66699 3.5668 1.93948 3.03202C2.17916 2.56161 2.56161 2.17916 3.03202 1.93948C3.5668 1.66699 4.26686 1.66699 5.66699 1.66699H14.3337C15.7338 1.66699 16.4339 1.66699 16.9686 1.93948C17.439 2.17916 17.8215 2.56161 18.0612 3.03202C18.3337 3.5668 18.3337 4.26686 18.3337 5.66699V14.3337C18.3337 15.7338 18.3337 16.4339 18.0612 16.9686C17.8215 17.439 17.439 17.8215 16.9686 18.0612C16.8742 18.1093 16.7746 18.1489 16.667 18.1815M3.33368 18.1815C3.33395 17.5071 3.338 17.1502 3.39771 16.85C3.66073 15.5277 4.69439 14.4941 6.01669 14.231C6.33869 14.167 6.7259 14.167 7.50033 14.167H12.5003C13.2748 14.167 13.662 14.167 13.984 14.231C15.3063 14.4941 16.3399 15.5277 16.6029 16.85C16.6627 17.1502 16.6667 17.5071 16.667 18.1815M13.3337 7.91699C13.3337 9.75794 11.8413 11.2503 10.0003 11.2503C8.15938 11.2503 6.66699 9.75794 6.66699 7.91699C6.66699 6.07604 8.15938 4.58366 10.0003 4.58366C11.8413 4.58366 13.3337 6.07604 13.3337 7.91699Z",
    stroke: "#344054",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_42308_1517"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowProfileIcon);
export default __webpack_public_path__ + "static/media/ShowProfileIcon.4837cd8596f04f1630820fccc80b482c.svg";
export { ForwardRef as ReactComponent };